module.exports = __webpack_public_path__ + "img/bg_mobile.d80a60a9.png";